<template>
  <Panel>
    <template #header>
      Add Credit Card
    </template>

    <template #content>
      <div class="w-50">
        <CreditCardForm
          :is-loading="isLoading"
          @submit="onSubmit"
          @success="onSuccess"
          @error="onError"
        />
      </div>
    </template>
  </Panel>
</template>

<script>
import CreditCardForm from '@/components/onboarding/CreditCardForm.vue'

export default {
  name: 'AddCreditCard',
  components: {
    CreditCardForm,
  },

  data() {
    return {
      isLoading: false
    }
  },
  head: {
    script: [
      {
        hid: 'spreedly-script1',
        src: 'https://core.spreedly.com/iframe/iframe-v1.min.js'
      }
    ]
  },
  methods: {
    onSubmit() {
      this.isLoading = true
    },
    onError() {
      this.isLoading = false
    },
    async onSuccess() {
      this.isLoading = false
      this.$router.push({ name: 'PaymentMethods' })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
